export const providerloc = [
    { value: '', label: "Please Select ..." },
    { label: 'Children National' },
    { label: 'CNPA' },
    { label: 'Community of Hope' },
    { label: 'Core Health' },
    { label: 'DOCIIS' },
    { label: 'EE Health Center' },
    { label: 'George Washington' },
    { label: 'Georgetown' },
    { label: 'Howard' },
    { label: 'Howard University' },
    { label: 'Kaiser' },
    { label: 'Mary Center' },
    { label: 'Medstar-WHC' },
    { label: 'Unity' },
    { label: 'Other' }
]